// v3.18-1379 PUSH-001 — Browser subscription helpers.
import api from './api';

const urlB64ToUint8Array = (b64) => {
  const pad = '='.repeat((4 - b64.length % 4) % 4);
  const s = (b64 + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(s);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  typeof window !== 'undefined'
  && 'serviceWorker' in navigator
  && 'PushManager' in window
  && 'Notification' in window;

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  } catch { return null; }
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration('/');
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function subscribeCurrentDevice(deviceLabel) {
  if (!pushSupported()) throw new Error('Push not supported in this browser');
  const perm = Notification.permission === 'granted'
    ? 'granted'
    : await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Notification permission denied');

  const { data } = await api.get('/push/vapid-public-key');
  const key = data?.key;
  if (!key) throw new Error('Server VAPID key not configured');

  const reg = await registerServiceWorker();
  if (!reg) throw new Error('Service worker unavailable');

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(key),
    });
  }

  const { data: saved } = await api.post('/push/subscribe', {
    subscription: sub.toJSON(),
    device_label: deviceLabel || navigator.userAgent.slice(0, 80),
  });
  return saved;
}

export async function unsubscribeCurrentDevice(subscriptionId) {
  await api.delete(`/push/subscriptions/${subscriptionId}`);
  const sub = await currentSubscription();
  if (sub) { try { await sub.unsubscribe(); } catch { /* noop */ } }
}
